// extracted by mini-css-extract-plugin
module.exports = {"button":"IconButton__button___3IuDT","iconRight":"IconButton__iconRight___2joRA","small":"IconButton__small___STuEz"};